import type { ComponentProps } from 'react';

import { Text } from '@backyard-ui/core';

import { type Pricing } from '@/infra/services/catalog/model';

interface InstallmentsProps extends Pick<Pricing, 'installment'> {
  textColor?: ComponentProps<typeof Text>['color'];
}

export default function Installments(props: Readonly<InstallmentsProps>) {
  const {
    installment: { brandedQuantity, quantity },
    textColor = 'neutral-700',
  } = props;

  const isInstallmentsOnly = quantity > 1 && brandedQuantity <= 1;
  const isBrandedInstallmentsOnly = quantity <= 1 && brandedQuantity > 1;
  const hasAnyInstallment = quantity > 1 || brandedQuantity > 1;

  if (!hasAnyInstallment) {
    return null;
  }

  if (isInstallmentsOnly) {
    return (
      <Text size="md" color={textColor} asChild>
        <span data-testid="content">
          em até <strong>{quantity}x</strong>
        </span>
      </Text>
    );
  }

  if (isBrandedInstallmentsOnly) {
    return (
      <Text size="md" color={textColor} asChild>
        <span data-testid="content">
          em até <strong>{brandedQuantity}x</strong> no cartão Celebre!
        </span>
      </Text>
    );
  }

  return (
    <Text size="md" color={textColor} asChild>
      <span data-testid="content">
        em até <strong>{quantity}x</strong> ou em até{' '}
        <strong>{brandedQuantity}x</strong> no cartão Celebre!
      </span>
    </Text>
  );
}
